import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import './curs-success-page.scss';

export default class CursSuccessPage extends Component {
  render() {
    return (
      <div className="registerSuccess error-page-sec pt-100 pb-100">
        <div className="container">
          <div className="row">
            <div className="col-md-3" />
            <div className="col-md-6">
              <div className="error-page-content">
                <h1>Felicitări</h1>
                <h2>Ați finalizat cursul cu succes.</h2>
                <h3>Adeverința de participare se va elibera în termen de 60 de zile de la data încheierii seriei și va fi expediată pe adresa de email pe care ați folosit-o la înscriere.</h3>
                <div className="registerSuccess-icon fa fa-check-circle" />
                <Link to="/">Inapoi la site</Link>
              </div>
            </div>
            <div className="col-md-3" />
          </div>
        </div>
      </div>
    );
  }
}
